<article class="container">
    <div class="row">
        <header class="col-12">
            <app-recipe-header [data]="data"></app-recipe-header>
        </header>
    </div>
    <div class="row main-row">
        <aside class="col-12 col-md-4">
            <app-recipe-ingredients [ingredientSections]="data.ingredientSections"></app-recipe-ingredients>
        </aside>
        <div class="col-12">
            <app-recipe-steps [instructionSections]="data.instructionSections"></app-recipe-steps>
        </div>
    </div>
</article>
